var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "title" }, [
        _vm._v("\n      实名认证服务协议\n    ")
      ]),
      _c("div", [
        _vm._v(
          "\n      实名认证服务协议（以下简称“本协议”）是重庆易保全网络科技有限公司（以下简称“平台”）与用户（以下尊 称“您”）就实名认证服务（以下简称“本服务”或“认证服务”）的使用等相关事项所订立的有效合约。 本协议有助于您了解我们为您提供的服务内容及您的权利和义务，请您仔细阅读。 为便于您使用认证服务，您通过网络页面点击或以其他形式确认本协议的，即视为您已充分理解本协议所有条款，并同意与平台订立本协议并接受本协议的约束。\n    "
        )
      ]),
      _c("h5", [_vm._v("一、定义")]),
      _c("div", [
        _vm._v(
          "实名认证服务：指平台提供的，通过信息核验、人脸比对、校验码回填、人工审核等方式确认您身份或您所属企业的真实性。"
        )
      ]),
      _c("h5", [_vm._v("二、授权与许可")]),
      _c("div", [
        _vm._v(
          "\n      1、为了向您提供认证服务的需要，向您提供产品或服务的商户（以下简称商户）需要将您在申请服务过程中所填写或留存的信息，例如企业名称、统一社会信用代码、姓名、身份证号码、手机号码提供给平台，同时为了准确核验您的身份，尽量防止您的身份被冒用，您授权平台采集您的设备信息以验证您在进行认证时是否处于可信环境，并根据您选择不同的认证方式按需收集您的人脸照片、身份证件、银行卡号、手机号、企业统一社会信用代码、企业对公账户等信息。"
        ),
        _c("br"),
        _vm._v(
          "\n2、为准确验证您的身份，平台需将前款载明的信息提供给合法存有您信息的第三方机构进行比对核验，以便平台核验您的身份真实性。"
        ),
        _c("br")
      ]),
      _c("h5", [_vm._v("三、您的权利义务")]),
      _c("div", [
        _vm._v(
          "\n      1、 平台会尽力提升核验结果的准确性，但由于平台能收集到的信息范围有限，以及行业技术水平及核验手段仍在完善过程中，平台无法确保核验结果完全准确无误。如您发现核验结果不准确，您可通过客服电话400-808-9187告知平台，以便我们重新核验并逐步提升核验能力。"
        ),
        _c("br"),
        _vm._v(
          "\n2.您应确保在实名认证过程中如实填写、提交真实、准确的身份信息、验证信息。"
        ),
        _c("br"),
        _vm._v(
          "\n3、您不得将本服务用于中国法律法规所限制或禁止，以及违背道德风俗的领域，否则因此导致平台或第三方遭受损失的，您应承担相应赔偿责任。"
        ),
        _c("br"),
        _vm._v(
          "\n4、如您发现我们收集、使用您个人信息的行为，违反了法律、行政法规规定或违反了与您的约定，或您发现我们采集、储存的您的个人信息有错误的，您可联系我们的客服电话400-808-9187，要求删除或更正。"
        ),
        _c("br"),
        _vm._v(
          "\n5、实名认证服务仅作为个人/企业身份真实性校验，并不能代表实名认证后签署的文件、合同具备法律效益。"
        ),
        _c("br")
      ]),
      _c("h5", [_vm._v("四、平台的权利义务")]),
      _c("div", [
        _vm._v("\n      1、平台应按本协议约定向您提供认证服务。"),
        _c("br"),
        _vm._v(
          "\n2、平台会根据认证技术的发展及市场风险环境的需要，不断调整完善相应认证服务的内容。"
        ),
        _c("br"),
        _vm._v(
          "\n3、除根据法律法规规定及本协议对您的个人信息予以保护外，在处理您的信息时，我们将依据《用户隐私政策》严格保护您的信息。请您仔细阅读该政策，如有任何疑问，请随时联系我们。"
        ),
        _c("br")
      ]),
      _c("h5", [_vm._v("五、除外责任")]),
      _c("div", [
        _vm._v(
          "\n      您理解并同意，鉴于计算机、互联网的特殊性，下述情况不属于平台违约："
        ),
        _c("br"),
        _vm._v(
          "\n      1、因自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断、网路堵塞、电信部门技术调整和政府管制等导致本服务不能提供或中断；"
        ),
        _c("br"),
        _vm._v(
          "\n2、黑客攻击造成服务中断、信息数据泄露；但我们应按照本协议约定做好应急处理。"
        ),
        _c("br"),
        _vm._v("\n3、平台在进行服务器配置、维护时，需要短时间中断服务；"),
        _c("br"),
        _vm._v("\n4、由于Internet上的通路阻塞造成您网站访问速度下降；"),
        _c("br"),
        _vm._v("\n5、因国家法律法规及政策的相关要求，中断或终止本服务。"),
        _c("br")
      ]),
      _c("h5", [_vm._v("六、协议变更")]),
      _c("div", [
        _vm._v(
          "\n      为了满足您多样化和专业化的服务需求，我们将根据国家法律、法规及其他规范性文件及业务需要，可能增加、变更服务内容或服务方式，我们可能对本协议内容进行变更，并以在平台官方网站 （www.junziqian.com）发布公告的方式提前予以公布。若您不接受本协议的变更，您有权自主决定选择停止使用本服务。若您在公告约定的生效时间后继续使用本服务的，表示您已充分阅读、理解并接受变更修改后的协议内容。\n    "
        )
      ]),
      _c("h5", [_vm._v("七、适用法律及管辖条款")]),
      _c("div", [
        _vm._v(
          "\n      本协议适用中华人民共和国法律（仅为本协议之目的，不包括香港特别行政区、澳门特别行政区及台湾地区法律）。因平台与您就本协议的签订、履行或解释发生争议，双方应努力友好协商解决。如协商不成的，平台和您均同意提交重庆仲裁委员会进行仲裁解决。\n    "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e06ffff6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e06ffff6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/auth/APIAuth/components/protocalNew/pItems/RealName.vue
// module id = ttya
// module chunks = 256